import React from 'react';

// Material-UI components
import { styled } from '@mui/styles';
import LinearProgress from '@mui/material/LinearProgress';

// Styled component using Material-UI's styled API
const LoaderRoot = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1301,
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2),
    },
}));

//-----------------------|| Loader ||-----------------------//

const Loader = () => {
    return (
        <LoaderRoot>
            <LinearProgress color="primary" />
        </LoaderRoot>
    );
};

export default Loader;
